export const METHODS = {
  GET: 'GET',
  CREATE: 'CREATE',
  VERIFY: 'VERIFY',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
}

export const STATUS = {
  LOADING: 'LOADING',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
}

export const SETTINGS_NOTIFICATION_LABELS = {
  addressBookLabels: {
    [METHODS.UPDATE]: 'account.address.saved.confirmation',
    [METHODS.CREATE]: 'account.confirmation.address.added',
    [METHODS.DELETE]: 'account.confirmation.address.removed',
    [STATUS.FAILURE]: 'myaccount.address.submit.error',
  },
  paymentsLabels: {
    [METHODS.UPDATE]: 'my.account.payment.bank.account.updated',
    [METHODS.CREATE]: 'my.account.payment.bank.account.add',
    [METHODS.DELETE]: 'my.account.payment.bank.account.remove',
    [STATUS.FAILURE]: 'my.account.payment.bank.account.error',
  },
}
